import classNames from 'classnames';
import React, { useState, useEffect } from 'react';
import {
  Row, Col,
} from 'reactstrap';

import LocaleService from '@services/LocaleService';
import { CustomButton } from '@shared/buttons';
import CustomModal from '@shared/components/modal/CustomModal';
import {
  CloseIcon,
} from '@shared/icons';

import './ConfirmModalStyle.scss';

const i18nGeneral = LocaleService.getTranslations('general');

type ConfirmModalType = {
  show: (data: any) => void;
  hide: () => void;
};

export const ConfirmModal: ConfirmModalType = {
  show: () => {},
  hide: () => {},
};

export const useConfirmModal: any = () => ConfirmModal;

const ConfirmModalComponent = () => {
  const [ showModal, setShowModal ] = useState(false);
  const [ loading, setLoading ] = useState(false);
  const [ modalProps, setModalProps ] = useState<any>({
    title: '',
    body: '',
    onConfirm: () => {},
  });

  const confirmClose = () => {
    if (modalProps.onCancel) {
      modalProps.onCancel();
    }
    setModalProps({
      title: '',
      body: '',
      onConfirm: () => {},
      onCancel: () => {},
    });
    setShowModal(false);
  };

  const onConfirm = async () => {
    setLoading(true);
    await modalProps.onConfirm();
    setLoading(false);
    confirmClose();
  };

  useEffect(() => {
    ConfirmModal.show = (data: any) => {
      setModalProps({
        title: data?.title,
        body: data?.body || data?.message,
        onConfirm: data?.onConfirm,
        onCancel: data?.onCancel ?? null,
        confirmBtnLabel: {
          name: data?.confirmBtn?.name || i18nGeneral.button.confirm.name,
        },
        cancelBtnLabel: {
          name: data?.cancelBtn?.name || i18nGeneral.button.cancel.name,
        },
        isDelete: data?.isDelete,
        isSingleButton: data?.isSingleButton,
      });
      setShowModal(true);
    };
    ConfirmModal.hide = () => confirmClose();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!showModal) return null;

  return (
    <CustomModal
      open={showModal}
      toggle={confirmClose}
      noFooter
      noHeader
      modalProps={{ centered: true, id: 'custom-confirm-modal', className: 'modal-lg' }}
    >
      <div className="confirm-modal-container">
        <Row className="mb-4">
          <Col xs={10}>
            <span
              className={classNames('confirm-modal-title', {
                'confirm-modal-title-delete': modalProps?.isDelete,
              })}
            >
              {modalProps?.title}
            </span>
          </Col>
          <Col xs={2} className="text-end">
            <a
              aria-label="Close"
              role="button"
              href="#"
              onClick={(e: any) => {
                e.preventDefault();
                setShowModal(false);
              }}
            >
              <CloseIcon />
            </a>
          </Col>
        </Row>
        <Row className="mb-4">
          <Col>
            <span className="confirm-modal-description">
              {modalProps?.body}
            </span>
          </Col>
        </Row>
        {!modalProps?.isSingleButton && (
          <Row className="buttons-row-style">
            <Col md={6}>
              <CustomButton
                id="btn-back-modal-cancel"
                disabled={loading}
                color="secondary"
                className={classNames('btn-lg confirm-modal-custom-btn-style', {
                  'delete-cancel-btn-style': modalProps?.isDelete,
                })}
                onClick={confirmClose}
              >
                {modalProps?.cancelBtnLabel?.name}
              </CustomButton>
            </Col>
            <Col md={6}>
              <CustomButton
                id="btn-update-modal-cancel"
                loading={loading}
                disabled={loading}
                color="primary"
                className={classNames('btn-lg confirm-modal-custom-btn-style', {
                  'delete-btn-style': modalProps?.isDelete,
                })}
                onClick={onConfirm}
              >
                {modalProps?.confirmBtnLabel?.name}
              </CustomButton>
            </Col>
          </Row>
        )}
        {modalProps?.isSingleButton && (
          <Row>
            <Col>
              <CustomButton
                id="btn-update-modal-cancel"
                loading={loading}
                disabled={loading}
                color="primary"
                className={classNames('btn-lg confirm-modal-custom-btn-style', {
                  'delete-btn-style': modalProps?.isDelete,
                })}
                onClick={onConfirm}
              >
                {modalProps?.confirmBtnLabel?.name}
              </CustomButton>
            </Col>
          </Row>
        )}
      </div>
    </CustomModal>
  );
};

export default ConfirmModalComponent;
